module.exports = __webpack_public_path__ + "static/media/bigMagentaTemplate.b333fc25.png";